import { useNavigate } from 'react-router-dom';
import { Button, FormField, Alert, Icon } from '@chikara/ui';
import { useForgotPassword } from '@/features/auth/hooks/usePasswordReset';
import { t } from '@/i18n';
import * as ROUTES from '@/shared/constants/routes';
import styles from './ForgotPasswordPage.module.css';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const {
    email,
    emailError,
    success,
    apiError,
    isFormValid,
    isLoading,
    handleEmailChange,
    handleSubmit,
  } = useForgotPassword();

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.header}>
        <h2 className={styles.title}>{t('forgotPassword.title')}</h2>
        <p className={styles.subtitle}>{t('forgotPassword.subtitle')}</p>
      </div>

      <FormField
        label={t('forgotPassword.email')}
        type="email"
        value={email}
        onChange={handleEmailChange}
        error={emailError}
        required
      />

      {success && (
        <Alert variant="success" icon={<Icon name="check" color="inherit" />}>
          {t('forgotPassword.success')}
        </Alert>
      )}

      {apiError && (
        <Alert variant="error" icon={<Icon name="error" color="inherit" />}>
          {apiError}
        </Alert>
      )}

      <div className={styles.actions}>
        <Button
          type="submit"
          disabled={!isFormValid || success}
          isLoading={isLoading}
          className={styles.submitButton}
        >
          {t('forgotPassword.submit')}
        </Button>

        <Button
          variant="outline"
          className={styles.submitButton}
          type="button"
          onClick={() => navigate(ROUTES.LOGIN)}
        >
          {t('forgotPassword.back')}
        </Button>
      </div>
    </form>
  );
}

export { ForgotPasswordPage };
